import { useState } from "react";
import { StarIcon } from "lucide-react";
import { cn } from "@util/tailwind";

interface StarRatingProps {
    totalStars?: number;
    initialRating?: number;
    size?: "sm" | "md" | "lg";
    onChange?: (rating: number) => void;
    className?: string;
}

export default function StarRating({
    totalStars = 5,
    initialRating = 0,
    size = "md",
    onChange,
    className,
}: StarRatingProps) {
    const [rating, setRating] = useState(initialRating);
    const [hoverRating, setHoverRating] = useState(0);

    const handleClick = (index: number) => {
        const newRating = index + 1;
        setRating(newRating);
        if (onChange) {
            onChange(newRating);
        }
    };

    const starSizes = {
        sm: "h-4 w-4",
        md: "h-6 w-6",
        lg: "h-8 w-8",
    };

    const containerSizes = {
        sm: "gap-1",
        md: "gap-2",
        lg: "gap-3",
    };

    return (
        <div className={cn("flex items-center", containerSizes[size], className)}>
            {[...Array(totalStars)].map((_, index) => {
                const isActive = (hoverRating || rating) > index;

                return (
                    <StarIcon
                        key={index}
                        className={cn(
                            starSizes[size],
                            "cursor-pointer transition-colors",
                            isActive
                                ? "fill-yellow-400 text-yellow-400"
                                : "fill-transparent text-gray-300 hover:text-gray-400"
                        )}
                        onMouseEnter={() => setHoverRating(index + 1)}
                        onMouseLeave={() => setHoverRating(0)}
                        onClick={() => handleClick(index)}
                    />
                );
            })}
        </div>
    );
}
